module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"No results."}}')
  delete Component.options._Ctor
}
